import { render, staticRenderFns } from "./RenovaDashboardLayout.vue?vue&type=template&id=23af7063&"
import script from "./RenovaDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./RenovaDashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./RenovaDashboardLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports